
import Layout from '@/views/layout/Layout';

const authCode = {
  path: '/approval',
  component: Layout,
  name: 'approvalEntry',
  redirect: '/approval/instance',
  children: [
    {
      name: 'approvalInstances',
      path: '/approval/instance',
      redirect: '/approval/instance/list/3',
      component: () => import('@/views/approval/instance/instanceView.vue'),
      meta: {
        title: '审批记录',
        isCrumb: true,
        backPage: true,
        isHistoryBack: true
      },
      children: [
        {
          name: 'approvalInstanceReview',
          path: '/approval/instance/review',
          component: () => import('@/views/approval/instance/review.vue'),
          meta: {
            title: '数据统计',
            isCrumb: true,
            isBack: true
          }
        },
        {
          name: 'approvalInstanceDetail',
          path: '/approval/instance/detail',
          component: () => import('@/views/approval/instance/instanceDetail/instanceDetail.vue'),
          meta: {
            title: '记录详情',
            isBack: true,
            isCrumb: true
          }
        },
        {
          name: 'approvalInstancePrint',
          path: '/approval/instance/print',
          component: () => import('@/views/approval/instance/instanceDetail/printFile.vue'),
          meta: {
            title: '打印',
            isBack: true,
            isCrumb: true
          }
        },
        {
          name: 'approvalInstancePrintMoney',
          path: '/approval/instance/print-spend-money',
          component: () => import('@/views/approval/instance/instanceDetail/printSpendMoney.vue'),
          meta: {
            title: '打印付款',
            isBack: true,
            isCrumb: true
          }
        },
        {
          name: 'approvalInstancesList',
          path: '/approval/instance/list/:type',
          component: () => import('@/views/approval/instance/approvalInstances.vue'),
          meta: {
            title: '列表',
            isBack: false,
            isCrumb: true
          }
        }
      ]
    },
    {

      name: 'approvalProject',
      path: '/approval/project',
      redirect: '/approval/project/list',
      component: () => import('@/views/approval/project/projectView.vue'),
      meta: {
        title: '审批流程',
        isCrumb: true,
        backPage: true
      },
      children: [
        {
          name: 'approvalProjectList',
          path: '/approval/project/list',
          component: () => import('@/views/approval/project/projectList.vue'),
          meta: {
            title: '审批流列表',
            isCrumb: true,
            isBack: false
          }
        },
        {
          name: 'approvalFlow',
          path: '/approval/project/flow',
          component: () => import('@/views/approval/project/approvalFlow.vue'),
          meta: {
            title: '配置审批流',
            isCrumb: true,
            isBack: true
          }
        },
        {
          name: 'approvalEditBase',
          path: '/approval/project/base-edit',
          component: () => import('@/views/approval/project/editBase/editBase.vue'),
          meta: {
            title: '编辑基本信息',
            isCrumb: true,
            isBack: true
          }
        },
      ]
    }
  ]
};

export default authCode;